<script>
  // Nenhum dado dinâmico é necessário aqui, já que é uma página informativa
</script>

<style>
  .back {
    margin: 0;
    padding: 0;
     background-image: url("/img/pista.jpg");
    background-size: cover;
     background-position: center; /* Para centralizar a imagem */ 
  }

  .section {
    padding: 40px 20px;
    color: #333;
    position: relative;
    margin: 20px 0; /* Espaçamento entre as seções */
    border-radius: 8px;
  }

  .section:nth-child(even) {
    background-color: #f8f9fa; /* Cor de fundo clara para seções pares */
  }

  .section:nth-child(odd) {
    background-color: #e9ecef; /* Cor de fundo um pouco mais escura para seções ímpares */
  }

  .section h1, .section h2 {
    text-align: center;
    color: #343a40;
    margin-bottom: 20px;
  }

  .section p {
    font-size: 18px;
    line-height: 1.6;
    margin-bottom: 20px;
  }

  .section ul {
    list-style-type: disc;
    padding-left: 20px;
  }

  .section ul li {
    margin-bottom: 10px;
  }

  .cta {
    text-align: center;
    margin-top: 40px;
  }

  .cta button {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .cta button:hover {
    background-color: #5a6268;
  }

  .cta p {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
</style>
<div class="back">

<br>
<br>
<div class="container">
  <!-- Seção 1: Introdução -->
  <div class="section">
    <h1>Programa de Afiliados</h1>
    <p>
      O nosso programa de afiliados permite que você ganhe comissões ao indicar novos clientes para nossa plataforma. O sistema é simples, e você pode começar a ganhar de duas maneiras:
    </p>
  </div>

  <!-- Seção 2: Como Funciona -->
  <div class="section">
    <h2>Como funciona</h2>
    <ul>
      <li><strong>1º Nível:</strong> Você ganha 10% ou 20% de comissão sobre os pagamentos realizados pelas pessoas que você indicou diretamente.</li>
      <li><strong>2º Nível:</strong> Quando as pessoas que você indicou convidam outras, você também ganha 5% ou 10% de comissão sobre os pagamentos desses novos indicados.</li>
    </ul>
    <p>
      Cada pagamento realizado por um indicado gera uma comissão, que será acumulada em um extrato. As comissões só podem ser resgatadas após 35 dias da geração, e o valor mínimo para resgate é de R$20,00. O resgate poderá ter uma taxa administrativa, que será informada no momento do pedido de resgate.
    </p>
  </div>

  <!-- Seção 3: Regras para Resgate -->
  <div class="section">
    <h2>Regras para resgate</h2>
    <ul>
      <li>O valor mínimo para solicitar o resgate é de R$20,00.</li>
      <li>O tempo mínimo para liberar o resgate é de 35 dias a partir da geração da comissão.</li>
      <li>O pagamento é realizado diretamente na sua conta bancária ou pode ser utilizado para abater mensalidades em atraso no aplicativo.</li>
    </ul>
  </div>

  <!-- Seção 4: Chamada para Ação -->
  <div class="section">
    <h2>Seja um afiliado agora!</h2>
    <p>
      Se você ainda não é cadastrado no nosso sistema de afiliados, clique no botão abaixo para se cadastrar e começar a ganhar comissões ao indicar novos clientes. Se você já contratou algum dos nossos planos, você já é um afiliado automaticamente! Basta acessar a área "Meu Perfil" e obter o seu link de indicação.
    </p>

    <div class="cta">
      <p>Não perca tempo! Cadastre-se agora e comece a ganhar comissões:</p>
      <button on:click={() => alert('Cadastro de afiliados em breve!')}>Cadastrar-se como afiliado</button>
    </div>

    <div class="cta">
      <p>Já é nosso cliente? Obtenha seu link de indicação na área "Meu Perfil":</p>
      <button on:click={() => alert('Acesse "Meu Perfil" para obter seu link.')}>Ir para "Meu Perfil"</button>
    </div>
  </div>
</div>
<br>
<br></div>